export default {
  fr: {
    privacy: '173',
    terms: '175'
  },
  en: {
    privacy: '173',
    terms: '175'
  },
  nl: {
    privacy: '173',
    terms: '175'
  }
}
